export default __webpack_public_path__ + "6222fe0b74c0d30a7bb33c7197817817.webp";